import { DOMAIN_TYPE_CHAT_THREAD } from '../../../consts';
export var getThread = function (state) {
    return function (threadId) {
        return state.domain[DOMAIN_TYPE_CHAT_THREAD]
            ? state.domain[DOMAIN_TYPE_CHAT_THREAD][threadId]
            : null;
    };
};
